import React from "react";
import "../styles/HowItWorks.css"; // Import CSS
import StatCardThree from "./StatCardThree"; // Reusing the Stats card

const HowItWorks = () => {
  return (
    <section className="how-it-works">
      {/* ✅ NEW FRAME: Wraps Everything */}
      <div className="how-it-works__frame">
      {/* Left Side - Background Image */}
      <div className="how-it-works__image">
        <img src="/works.jpg" alt="Background" />
        <div className="how-it-works__stat-card how-it-works-card">
          <StatCardThree />
        </div>
      </div>

      {/* ✅ NEW FRAME WRAPPER */}
      <div className="how-it-works__content-wrapper">
        {/* ✅ Title & Description */}
        <div className="how-it-works__text">
          <h2>How It Works</h2>
          <p>Step-by-Step Process</p>
        </div>

        {/* ✅ Steps Frame */}
        <div className="how-it-works__steps">
          {/* Step 1 */}
          <div className="step">
            <div className="step-icon">
              <img src="/step 1.svg" alt="Step 1 Icon" />
            </div>
            <div className="step-text">
              <h3>Step 1</h3>
              <p>Upload your document.</p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="step">
            <div className="step-icon">
              <img src="/step 2.svg" alt="Step 2 Icon" />
            </div>
            <div className="step-text">
              <h3>Step 2</h3>
              <p>Enter recipient details.</p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="step">
            <div className="step-icon">
              <img src="/step 3.svg" alt="Step 3 Icon" />
            </div>
            <div className="step-text">
              <h3>Step 3</h3>
              <p>Choose delivery options.</p>
            </div>
          </div>

          {/* Step 4 */}
          <div className="step">
            <div className="step-icon">
              <img src="/step 4.svg" alt="Step 4 Icon" />
            </div>
            <div className="step-text">
              <h3>Step 4</h3>
              <p>Make a secure payment.</p>
            </div>
          </div>
        </div>
      </div>
      </div> {/* ✅ End of Frame */}
    </section>
  );
};

export default HowItWorks;
